module.exports = __webpack_public_path__ + "img/solution4.175962a9.jpg";